import { combineReducers } from 'redux';
import application from './reducers/application';
import gto from './reducers/gto';
import login from './reducers/login';
import plans from './reducers/plans';
import procedures from './reducers/procedures';

const rootReducer = combineReducers({
  application,
  gto,
  login,
  plans,
  procedures
});

export default rootReducer;
